// Public site bundle. Keep this lean — every byte here is downloaded by every
// visitor. Anything only the back office needs belongs in `admin.js`.
require("@rails/ujs").start()
require("turbolinks").start()
window.$ = window.jQuery = require('jquery');
require('bootstrap');
require('./libs/flash-messenger.min');
require('./libs/flash-messenger-ext');
require('./libs/flash-messenger-bootstrap');

$(document).on('turbolinks:load', function() {
  if (document.getElementsByTagName('usertime').length) {
    import(/* webpackChunkName: "usertime" */ '../src/usertime').then(function () {
      window.UserTime.convert();
    });
  }

  $('[data-ride="carousel"]').each(function () {
    $(this).carousel();
  });

  $('.review').click(function () {
    var url = $(this).find('img').attr('src');
    $('#image').html('<img src="' + url + '" / >');
    $('#modal').modal();
  });
});
